import React, { useRef, useState } from 'react';
import CloseIcon from '@material-ui/icons/Close';
import ViewColumnIcon from '@material-ui/icons/ViewColumn';
import {
  Checkbox,
  FormControl,
  FormControlLabel,
  FormGroup, IconButton,
  Popover,
  Tooltip,
  Typography,
  makeStyles
} from '@material-ui/core';


const useStyles = makeStyles((theme) => ({
  root: {
    padding: '16px 24px 16px 24px',
    fontFamily: 'Roboto',
  },
  title: {
    marginLeft: '-7px',
    marginRight: '24px',
    fontSize: '14px',
    color: theme.palette.text.secondary,
    textAlign: 'left',
    fontWeight: 500,
  },
  closeButton: {
    position: 'absolute',
    right: '4px',
    top: '4px',
    zIndex: 1000
  },
  formGroup: {
    marginTop: '8px',
  },
  formControl: {},
  checkbox: {
    padding: '0px',
    width: '32px',
    height: '32px',
  },
  checkboxRoot: {},
  checked: {},
  label: {
    fontSize: '15px',
    marginLeft: '8px',
    color: theme.palette.text.primary,
  },
}));


const ViewColumn = ({ storageKey, tableCells, setHeadTableCells, iconColor = 'inherit',}) => {
  const classes = useStyles();
  const [isOpen, open] = useState(false);
  const iconRef = useRef();

  const handleRequestClose = () => {
    open(false);
  };

  const handleColumnToggle = (event, index) => {
    const updatedTableCells = [...tableCells];
    updatedTableCells[index].display = event.target.checked;

    localStorage.setItem(storageKey, JSON.stringify(updatedTableCells));
    setHeadTableCells(updatedTableCells);
  };


  return (
    <>
      <Tooltip title={'View Columns'} disableFocusListener>
        <IconButton
          onClick={() => {
            open(true);
          }}
          ref={iconRef}
          className="p-2"
        >
          <ViewColumnIcon style={{color: iconColor}} />
        </IconButton>
      </Tooltip>
      <Popover
        anchorEl={iconRef.current}
        open={isOpen}
        onClose={handleRequestClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <IconButton
          aria-label="Close"
          onClick={handleRequestClose}
          className={classes.closeButton}
        >
          <CloseIcon />
        </IconButton>
        <FormControl component={'fieldset'} className={classes.root}>
          <Typography variant="caption" className={classes.title}>
            {'Show columns'}
          </Typography>
          <FormGroup className={classes.formGroup}>
            {tableCells.map((column, index) => {
              if (column.sortField === 'practice_name') {
                return null;
              }

              return (
                <FormControlLabel
                  key={index}
                  control={
                    <Checkbox
                      color="primary"
                      className={classes.checkbox}
                      data-description="table-view-col"
                      onChange={(event) => handleColumnToggle(event, index)}
                      checked={column.display === true}
                      value={column.label}
                    />
                  }
                  label={<div dangerouslySetInnerHTML={{__html: column.label}} />}
                />
              );
            })}
          </FormGroup>
        </FormControl>
      </Popover>
    </>
  );
};

export default ViewColumn;
